import { ChangeEvent, useRef } from "react";
import { makeStyles } from "tss-react/mui";
import { IUploadedFile } from "@miplatform/types";
import { mdiImagePlusOutline } from "@mdi/js";
import { Box } from "@mui/material";
import { MiIcon } from "../MiIcon/MiIcon";
import { MiIconButton } from "../MiIconButton/MiIconButton";
import { MiImagePreview } from "../MiImagePreview/MiImagePreview";

export const MiImageUpload = ({
  disabled = false,
  image,
  onChange,
  testId = "mi-image-upload",
}: {
  disabled?: boolean;
  image?: File | IUploadedFile;
  onChange: (e: ChangeEvent<HTMLInputElement> | null) => void;
  testId?: string;
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const { classes } = useStyles({ disabled });

  const handleClick = (
    _e?: React.MouseEvent<HTMLButtonElement | HTMLDivElement>
  ) => {
    if (image) {
      onChange(null);
      return;
    }
    fileInputRef.current?.click();
  };

  return (
    <Box className={classes.imageUpload}>
      {image ? (
        <MiImagePreview
          url={URL.createObjectURL(image)}
          handleDelete={() => onChange(null)}
        />
      ) : (
        <MiIconButton
          disabled={disabled}
          className={classes.uploadButton}
          onClick={handleClick}
        >
          <MiIcon path={mdiImagePlusOutline} />
          <input
            type="file"
            ref={fileInputRef}
            className={classes.fileInput}
            data-testid={`${testId}-input`}
            onChange={onChange}
            accept="image/*"
          />
        </MiIconButton>
      )}
    </Box>
  );
};

interface StyleProps {
  disabled: boolean;
}
const useStyles = makeStyles<StyleProps>()((theme, { disabled }) => ({
  imageUpload: {
    height: 40,
    width: 40,
  },
  uploadButton: {
    color: disabled
      ? theme.palette.action.disabled
      : theme.palette.text.primary,
    "&:focus-within": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  fileInput: { display: "none" },
}));
